import React, { useState } from 'react';
import { PageTransition } from '../transitions/PageTransition';
import { Santri } from '../../types';

interface PortalWaliBayarProps {
  santri: Santri;
}

export const PortalWaliBayar: React.FC<PortalWaliBayarProps> = ({ santri }) => {
  const [activeTab, setActiveTab] = useState<'tagihan' | 'menunggu' | 'riwayat'>('tagihan');
  const [selectedSantriFilter, setSelectedSantriFilter] = useState<string>('semua');

  // Hardcoded for now based on the template, using the specific color #40513B
  const primaryColor = '#40513B';

  const renderTabContent = () => {
    switch (activeTab) {
      case 'tagihan':
        return (
          <div className="flex flex-col gap-3 p-4 pt-4 pb-24">
            <div className="flex flex-col items-center justify-center rounded-2xl bg-red-50 p-6 shadow-sm border border-red-100 text-center relative overflow-hidden mb-2">
              <div className="absolute -left-10 -top-10 h-32 w-32 rounded-full bg-red-500 opacity-5 blur-2xl"></div>
              <p className="text-red-600 text-sm font-medium mb-1 z-10">Total Tagihan Belum Dibayar</p>
              <h2 className="text-[#111811] text-4xl font-extrabold tracking-tight z-10">Rp -</h2>
              <p className="text-gray-500 text-xs mt-2 z-10">Gabungan tagihan {santri.nama}</p>
            </div>
            <div className="flex items-center justify-between mb-1 mt-2">
              <h3 className="text-[#111811] text-lg font-bold">Daftar Tagihan</h3>
              <div className="flex gap-2">
                <span className="px-2 py-1 bg-[#40513B]/10 text-[#40513B] text-xs font-bold rounded-md">Semua</span>
                <span className="px-2 py-1 bg-gray-100 text-gray-500 text-xs font-medium rounded-md">Bulanan</span>
              </div>
            </div>
            {/* Empty State / Placeholder */}
            <div className="flex flex-col items-center justify-center py-12 text-center">
               <p className="text-sm text-gray-500 italic">Belum ada data tagihan.</p>
            </div>
          </div>
        );
      case 'menunggu':
        return (
          <div className="flex flex-col gap-3 p-4 pt-4 pb-24">
            <div className="flex flex-col rounded-2xl bg-white p-5 shadow-sm border border-gray-100 relative overflow-hidden mb-2">
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-[#40513B] opacity-5 blur-2xl"></div>
              <div className="flex flex-col items-center justify-center mb-6 relative z-10">
                <p className="text-gray-500 text-xs font-medium mb-1.5 uppercase tracking-wide">Total Dalam Proses</p>
                <h2 className="text-[#111811] text-4xl font-extrabold tracking-tight">Rp -</h2>
              </div>
              <div className="grid grid-cols-2 gap-3 relative z-10">
                <div className="flex items-center gap-3 p-3 rounded-xl bg-yellow-50 border border-yellow-100">
                  <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-yellow-100 text-yellow-600">
                    <span className="material-symbols-outlined text-[18px]">schedule</span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[10px] font-bold text-gray-500 uppercase">Menunggu Bayar</span>
                    <p className="text-[#111811] text-sm font-bold">- Tagihan</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 rounded-xl bg-blue-50 border border-blue-100">
                  <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600">
                    <span className="material-symbols-outlined text-[18px]">hourglass_empty</span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[10px] font-bold text-gray-500 uppercase">Verifikasi</span>
                    <p className="text-[#111811] text-sm font-bold">- Tagihan</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between mb-1 mt-2">
              <h3 className="text-[#111811] text-lg font-bold">Rincian Proses</h3>
              <div className="flex gap-2">
                <span className="px-2 py-1 bg-yellow-100 text-yellow-700 text-xs font-bold rounded-md">Pending</span>
              </div>
            </div>
             {/* Empty State / Placeholder */}
             <div className="flex flex-col items-center justify-center py-12 text-center">
               <div className="bg-yellow-50 p-4 rounded-full mb-3">
                 <span className="material-symbols-outlined text-4xl text-yellow-600">pending_actions</span>
               </div>
               <h3 className="text-lg font-bold text-gray-900">Tidak ada tagihan menunggu</h3>
               <p className="text-sm text-gray-500 max-w-xs">Semua pembayaran Anda telah dikonfirmasi.</p>
             </div>
          </div>
        );
      case 'riwayat':
        return (
          <div className="flex flex-col gap-3 p-4 pt-4 pb-24">
            <div className="flex flex-row items-center justify-between rounded-2xl bg-green-50 p-5 shadow-sm border border-green-100 mb-2 relative overflow-hidden">
              <div className="absolute right-0 top-0 h-24 w-24 rounded-full bg-green-500 opacity-5 blur-2xl transform translate-x-8 -translate-y-8"></div>
              <div className="flex items-center gap-4 z-10">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100 text-green-600 shrink-0">
                  <span className="material-symbols-outlined text-2xl">check_circle</span>
                </div>
                <div>
                  <p className="text-green-800 text-xs font-medium">Total Tagihan Terbayar</p>
                  <p className="text-[#111811] text-2xl font-extrabold tracking-tight mt-0.5">Rp -</p>
                  <p className="text-xs text-green-700/60 mt-0.5">Bulan ini</p>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between mb-1 mt-2">
              <h3 className="text-[#111811] text-lg font-bold">Riwayat Transaksi</h3>
              <button className="flex items-center gap-1 text-[#40513B] text-xs font-bold px-2 py-1 rounded-md hover:bg-[#40513B]/5 transition-colors">
                <span className="material-symbols-outlined text-sm">filter_list</span>
                Filter
              </button>
            </div>
             {/* Empty State / Placeholder */}
             <div className="flex flex-col items-center justify-center py-12 text-center">
               <p className="text-sm text-gray-500 italic">Belum ada riwayat transaksi.</p>
             </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <PageTransition>
      <div className="min-h-screen bg-[#f6f8f6] text-[#111811] font-sans antialiased pb-32">
        <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden pb-32">
          {/* Header & Tabs */}
          <div className="bg-white rounded-b-3xl shadow-sm pb-2 sticky top-0 z-30">
            <div className="flex items-center justify-between p-4 pt-6">
              <div>
                <h2 className="text-xl font-bold tracking-tight text-[#111811]">Pembayaran</h2>
              </div>
              <div className="flex items-center gap-2">
                <button className="relative rounded-full bg-gray-100 p-2 text-gray-500 hover:text-[#40513B] transition-colors focus:outline-none focus:ring-2 focus:ring-[#40513B]/50">
                  <span className="material-symbols-outlined text-2xl">notifications</span>
                  <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
                </button>
              </div>
            </div>
            <div className="px-2">
              <div className="flex border-b border-gray-100 relative">
                <button
                  onClick={() => setActiveTab('tagihan')}
                  className={`flex-1 pb-3 pt-2 text-sm ${activeTab === 'tagihan' ? 'font-bold text-[#40513B] border-b-2 border-[#40513B]' : 'font-medium text-gray-500 hover:text-gray-700'} relative transition-colors`}
                >
                  Belum Bayar
                  <span className="ml-1 px-1.5 py-0.5 bg-red-100 text-red-600 text-[10px] rounded-full">-</span>
                </button>
                <button
                  onClick={() => setActiveTab('menunggu')}
                  className={`flex-1 pb-3 pt-2 text-sm ${activeTab === 'menunggu' ? 'font-bold text-[#40513B] border-b-2 border-[#40513B]' : 'font-medium text-gray-500 hover:text-gray-700'} transition-colors`}
                >
                  Menunggu
                </button>
                <button
                  onClick={() => setActiveTab('riwayat')}
                  className={`flex-1 pb-3 pt-2 text-sm ${activeTab === 'riwayat' ? 'font-bold text-[#40513B] border-b-2 border-[#40513B]' : 'font-medium text-gray-500 hover:text-gray-700'} transition-colors`}
                >
                  Riwayat
                </button>
              </div>
            </div>
            <div className="px-4 mt-4 mb-2">
              <p className="text-xs font-medium text-gray-500 mb-2">Pilih Santri:</p>
              <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
                <button
                  onClick={() => setSelectedSantriFilter('semua')}
                  className={`shrink-0 px-4 py-2 ${selectedSantriFilter === 'semua' ? 'bg-[#111811] text-white border-[#111811]' : 'bg-white border-gray-200 text-gray-600'} text-xs font-bold rounded-full shadow-md transition-transform active:scale-95 border`}
                >
                  Semua Santri
                </button>
                <button
                  onClick={() => setSelectedSantriFilter('santri')}
                  className={`shrink-0 px-4 py-2 ${selectedSantriFilter === 'santri' ? 'bg-[#111811] text-white border-[#111811]' : 'bg-white border-gray-200 text-gray-600'} text-xs font-medium rounded-full hover:bg-gray-50 transition-colors border`}
                >
                  {santri.nama.split(' ')[0]}
                </button>
              </div>
            </div>
          </div>

          {/* Content */}
          {renderTabContent()}

          {/* Floating Action Button (Only for 'tagihan') */}
          {activeTab === 'tagihan' && (
            <div className="fixed bottom-[80px] right-4 z-40">
              <button className="group flex items-center gap-2 bg-[#40513B] text-white px-5 py-3 rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                <span className="material-symbols-outlined text-xl">account_balance_wallet</span>
                <span className="font-bold text-sm whitespace-nowrap">Bayar Sekarang</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </PageTransition>
  );
};
